export const defaultSiteContent = {
    home: {
        video: '',
        poster: 'public/home1.jpg',
        links: [
            { to: '/urodziny/planowanie', content: 'Zaplanuj swoje Urodziny!' },
            { to: '/polkolonie/zapisy', content: 'Zapisz się na półkolonie!' },
            { to: '/kawiarnia/menu', content: 'Sprawdź menu naszej Kawiarni!' },
            {
                to: '/kontakt/informacje',
                content: 'Potrzebujesz informacji? Skontaktuj się z nami!',
            },
        ],
        tiles: [
            { href: '/urodziny/informacje', content: 'Urodziny' },
            { href: '/polkolonie/informacje', content: 'Półkolonie' },
            { href: '/indywidualnie/informacje', content: 'Sala Zabaw' },
            { href: '/grupy/informacje', content: 'Grupy' },
            { href: '/wypozyczalnia/informacje', content: 'Wypożyczalnia' },
            { href: '/kawiarnia/informacje', content: 'Kawiarnia' },
            { href: '/artykul/replay', content: 'Replay' },
            { href: '/escape_game/informacje', content: 'Escape Game' },
            { href: '/grupy/szkoly', content: 'Wynajmij Nas!' },
        ],
        slider: {
            images: [
                'public/home1.jpg',
                'public/home2.jpg',
                'public/home3.jpg',
                'public/home4.jpg',
            ],
        },
    },
    footer: {
        hours: [
            { label: 'Poniedziałek - Piątek', value: '10:00 - 20:00' },
            { label: 'Sobota', value: '09:00 - 20:00' },
            { label: 'Niedziela', value: '09:00 - 20:00' },
        ],
        contact: [
            { label: 'Telefon', value: '601 959 351' },
            { label: 'Telefon', value: '601 959 022' },
            { label: 'Adres', value: 'ul. Nieduża 4, 31-443 Kraków' },
            { label: 'Email', value: 'anikino@anikino.pl' },
        ],
        social: {
            facebook: 'https://www.facebook.com/salazabawkrakow',
            instagram: 'https://www.instagram.com/anikino_krakow/',
            tiktok: '',
        },
    },
    popup: {
        enabled: false,
        title: 'Specjalna oferta',
        image: '',
        url: '',
    },
};

export default defaultSiteContent;
